import {createContext} from 'react'

export default createContext({
  currentStep: 1,
})
